const hasDuplicatesInArrays = (arr1, arr2) => {
  if (!arr1 || !arr2) return false
  // Create a set from arr2 for faster lookup
  const set = new Set(arr2);

  // Iterate through arr1 and check if any item exists in arr2
  for (let item of arr1) {
    if (set.has(item)) {
      return true; // Duplicate found
    }
  }

  return false; // No duplicates found
}

export default hasDuplicatesInArrays